import { createApp } from 'vue';
import App from './App.vue';
import router from './router'
import { filters } from './filters'

import './assets/styles/base.css';
import './assets/styles/tailwind.css';

// import './assets/styles/common/comv4.css';
import './assets/styles/common/common.scss';

import addPlugin from './plugins/vue/addPlugin';

// import '@css/mobile/comv4.css';
import './assets/styles/mobile/mobile.scss';

// import '@css/pc/comv4.scss';
import './assets/styles/pc/pc.scss';

// import {
//   Table,
//   Tabs, 
//   TabPane,
//   // Picker,
//   // Popup,
//   // Countdown,
//   // Swiper,
//   // SwiperItem,
//   // Image,
//   // InfiniteLoading
// } from '@nutui/nutui';
// import NutUI from "@nutui/nutui";
// import '@nutui/nutui/dist/style.css';
import { useStore, useData, Game } from './store';

// 日志记录脚本
import DataReporter from './utils/DataReporter';
const reporter = new DataReporter();

const app = createApp(App);
app.use(router);
app.use(addPlugin);
// app.use(NutUI);
app.provide('GlobalStore', useStore());
app.provide('GlobalData', useData());
app.provide('Game', Game());
app.provide('GlobalReporter', reporter);
app.provide('filters', filters)
app.mount('#app');

console.log('当前变量', import.meta.env);
